/* mjade-prefetch — 누르기 «전에» 다음 페이지를 미리 받아 둔다 (2026-09-02)
 *
 * 왜 [2026-09-02 실측]
 *   이 몰은 요청 하나하나에 기본 0.5~0.6초가 붙는다(거리·플랫폼).
 *     GET /cart.js ................ 578~677ms   (내용이 거의 없는 것인데도)
 *     상품 상세 HTML .............. 1,314~1,424ms
 *     목록 HTML ................... 663~1,021ms
 *   그래서 «누르고 나서» 받기 시작하면 무엇을 해도 1초 넘게 빈다.
 *   마우스를 올린 순간(모바일은 손이 닿는 순간) 미리 받아 두면 누를 때는 이미 와 있다.
 *
 * 지키는 선
 *   · 같은 몰의 상품·목록·안내 페이지만. 남의 주소는 안 건드린다.
 *   · rel="prefetch" 는 «가장 낮은 순위» 라 지금 보는 화면과 자리를 다투지 않는다.
 *   · 데이터 절약 설정이거나 느린 회선(2G)이면 아무것도 안 한다.
 *   · 한 페이지에서 최대 6개까지만. 같은 주소는 한 번만.
 *   · 마우스는 90ms 머물러야 시작한다 — 지나가며 스치는 것까지 받지 않게.
 *
 * 되돌리기: theme.liquid 에서 이 파일 <script> 한 줄을 지운다.
 */
(function () {
  "use strict";
  if (window.__mjPrefetch) return;
  window.__mjPrefetch = true;

  try {
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ""))) return;
  } catch (e) {}

  var OK = /^\/(products|collections|pages)\//;
  var done = Object.create(null);
  var budget = 6;
  var timer = null;

  function target(el) {
    var a = el && el.closest ? el.closest("a[href]") : null;
    if (!a) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return null; }
    if (u.origin !== location.origin) return null;
    if (!OK.test(u.pathname)) return null;
    if (u.pathname === location.pathname) return null;      /* 지금 이 페이지 */
    if (a.hasAttribute("download") || a.target === "_blank") return null;
    var key = u.pathname + u.search;
    if (done[key]) return null;
    return key;
  }

  function take(key) {
    if (budget <= 0) return;
    done[key] = 1;
    budget -= 1;
    var l = document.createElement("link");
    l.rel = "prefetch";
    l.as = "document";
    l.href = key;
    document.head.appendChild(l);
  }

  /* 마우스: 90ms 머물면 받는다 */
  document.addEventListener("pointerover", function (e) {
    if (e.pointerType === "touch") return;                  /* 손가락은 아래에서 */
    var key = target(e.target);
    if (!key) return;
    clearTimeout(timer);
    timer = setTimeout(function () { take(key); }, 90);
  }, { passive: true });

  document.addEventListener("pointerout", function () { clearTimeout(timer); }, { passive: true });

  /* 손가락: 닿는 순간 받는다 — 손을 떼기까지 보통 100ms 쯤 벌 수 있다 */
  document.addEventListener("touchstart", function (e) {
    var key = target(e.target);
    if (key) take(key);
    rush(e.target);
  }, { passive: true, capture: true });

  /* ★ 2026-09-03 — «내가 누른 것부터» [대표님 지시]
     목록에는 사진이 수십 장 깔려 있고 브라우저는 그걸 «화면 차례» 로 받는다.
     그래서 내가 고른 칸의 사진이 아직 안 왔는데도 아래쪽 것들이 먼저 오는 일이 생긴다.
     손이 닿거나 마우스가 멈춘 그 칸의 사진을 «맨 앞» 으로 올린다.
       · 아직 안 받은 사진(loading="lazy")이면 그 자리에서 받게 한다
       · 이미 받는 중이면 우선순위만 높인다
     새로 받는 것이 아니라 «차례를 바꾸는» 것이라 데이터가 늘지 않는다. */
  function rush(el) {
    var card = el && el.closest ? el.closest("a[href], .product-block, li, article") : null;
    if (!card) return;
    var imgs = card.querySelectorAll("img");
    for (var i = 0; i < imgs.length && i < 3; i++) {
      var im = imgs[i];
      try { im.fetchPriority = "high"; } catch (err) {}
      if (im.getAttribute("loading") === "lazy") im.loading = "eager";
    }
  }
  document.addEventListener("pointerover", function (e) {
    if (e.pointerType === "touch") return;
    rush(e.target);
  }, { passive: true });
})();
